import { BiBold, BiItalic, BiListUl, BiListOl } from 'react-icons/bi';

export type ToolbarAction =
  | { type: 'bold' | 'italic' | 'bulletList' | 'orderedList' }
  | { type: 'heading'; level: 2 | 3 };

export const TOOLBAR_ACTIONS: ToolbarAction[] = [
  { type: 'bold' },
  { type: 'italic' },
  { type: 'heading', level: 2 },
  { type: 'heading', level: 3 },
  { type: 'bulletList' },
  { type: 'orderedList' },
];

export const TOOLBAR_BUTTON_LABELS: Record<string, React.ReactNode> = {
  bold: <BiBold />,
  italic: <BiItalic />,
  bulletList: <BiListUl />,
  orderedList: <BiListOl />,
  heading2: 'H2',
  heading3: 'H3',
};
